export default {
  // banner下方信息
  bannerBottomData: [
    {
      firstLineText: '19年+',
      secondLineText: '服务经验',
    },
    {
      firstLineText: '502万+',
      secondLineText: '企业服务',
    },
    {
      firstLineText: '2.7亿+',
      secondLineText: '个人用户',
    },
    {
      firstLineText: '121亿+',
      secondLineText: '总签署量',
    },
    {
      firstLineText: '24x365小时',
      secondLineText: '管家式服务',
    },
  ],
  // 集团型企业印章管理难点
  difficultyData: [
    {
      key: 1,
      title: '章在哪里？',
      imgSrc: require('@/assets/images/sem-local/difficulty-one.png'),
      contentList: ['现有印章总数多少？','各个印章对应负责人是谁？','各业务章目前所处位置？','在第三方平台有多少印章？']
    },
    {
      key: 2,
      title: '谁有权限？',
      imgSrc: require('@/assets/images/sem-local/difficulty-two.png'),
      contentList: ['印章的申请谁来负责？','业务上用章规则谁来配置？','印章的多级授权怎么做？','谁负责印章的停用、销毁？']
    },
    {
      key: 3,
      title: '安全吗？',
      imgSrc: require('@/assets/images/sem-local/difficulty-three.png'),
      contentList: ['非法盖印行为能否监控到？','裸章是否非授权不可触？','三方平台上印章如何管理？','电子章使用记录是否留痕？']
    },
    {
      key: 4,
      title: '盖了什么？',
      imgSrc: require('@/assets/images/sem-local/difficulty-four.png'),
      contentList: ['企业全年盖印的总数？','企业各印章盖了哪些文件？','每次盖印审批的详情在哪查看？','盖印文件是否能和业务绑定？']
    },
  ],
  // 实践部署流程
  deployProcessOneLine: [
    {
      key: 1,
      imgSrc: require('@/assets/images/sem-local/deploy-process-one.png'),
      text: '服务选型'
    },
    {
      key: 2,
      imgSrc: require('@/assets/images/sem-local/deploy-process-two.png'),
      text: '建设规划'
    },
    {
      key: 3,
      imgSrc: require('@/assets/images/sem-local/deploy-process-three.png'),
      text: '部署实施'
    },
    {
      key: 4,
      imgSrc: require('@/assets/images/sem-local/deploy-process-four.png'),
      text: '管理制度'
    },
  ],
  deployProcessTwoLine: [
    {
      key: 1,
      imgSrc: require('@/assets/images/sem-local/deploy-process-five.png'),
      text: '终端用户答疑'
    },
    {
      key: 2,
      imgSrc: require('@/assets/images/sem-local/deploy-process-six.png'),
      text: '落地协同'
    },
    {
      key: 3,
      imgSrc: require('@/assets/images/sem-local/deploy-process-seven.png'),
      text: '应用实践'
    },
  ],
  // “1+N”本地化系统+签署网络
  hybridCloudData: [
    {
      key: 1,
      imgSrc: require('@/assets/images/sem-local/hybrid-cloud-one.png'),
      titleOne: '1个系统，无签署网络',
      titleTwo: '平台方建设平台，要求相对方来使用',
      desc: '“平台单”系统型',
      contentList: [
        {
          key: 1,
          text: '本地化系统部署，合同文件隐私保护',
          status: true,
        },
        {
          key: 2,
          text: '相对方在平台方的系统里注册签署使用，没有属于自己的印章管理系统',
          status: false,
        },
        {
          key: 3,
          text: '不同平台需注册多账户多次认证，印章失控风险大',
          status: false,
        },
        {
          key: 4,
          text: '相对方在平台的印章使用和管理精细程度低',
          status: false,
        },
        {
          key: 5,
          text: '信息单向透明，受信任程度低，平台推广难',
          status: false,
        },
      ]
    },
    {
      key: 2,
      imgSrc: require('@/assets/images/sem-local/hybrid-cloud-two.png'),
      titleOne: '1+N个系统，一个签署网络',
      titleTwo: '平台方与相对方是两套独立的系统，使用同一个签署网络',
      desc: '“平台-相对方”双系统型',
      contentList: [
        {
          key: 6,
          text: '本地化系统部署，合同文件隐私保护',
          status: true,
        },
        {
          key: 7,
          text: '相对方在e签宝拥有自己的印章管理系统',
          status: true,
        },
        {
          key: 8,
          text: '相对方在e签宝平台统一管理印章及认证',
          status: true,
        },
        {
          key: 9,
          text: '相对方可在e签宝平台进行精细化权限管理',
          status: true,
        },
        {
          key: 10,
          text: 'e签宝第三方“社会化基础设施”平台效应，受信任程度高，用户易接受',
          status: true,
        },
      ]
    },
  ],
  // 物电一体统一管理
  wudianData: [
    {
      key: 1,
      title: '用印：物理印章',
      imgSrc: require('@/assets/images/sem-local/wudian-wu.png'),
    },
    {
      key: 2,
      title: '用印：电子印章',
      imgSrc: require('@/assets/images/sem-local/wudian-dian.png'),
    },
  ],
  // 统一印章信创替代解决方案
  solutionData: [
    {
      key: 1,
      imgSrc: require('@/assets/images/sem-local/solution-one.png'),
      title: '党政机关',
      textList: ['党政项目700+个','主要覆盖内部公文场景、电子档案、电子证照','省级信创项目3个']
    },
    {
      key: 2,
      imgSrc: require('@/assets/images/sem-local/solution-two.png'),
      title: '国央企',
      textList: ['用户覆盖全国','横跨8大行业']
    },
    {
      key: 3,
      imgSrc: require('@/assets/images/sem-local/solution-three.png'),
      title: '金融行业',
      textList: ['覆盖电子公文、电子保函，','电子凭证，三大应用场景']
    },
  ],
  // “五统一”构建企业印章管理新模式
  newModeData: [
    {
      key: 1,
      title: '统一用印-业权一体化',
      imgSrc: require('@/assets/images/sem-local/new-mode-one.png'),
    },
    {
      key: 2,
      title: '统一权限-精细化管理',
      imgSrc: require('@/assets/images/sem-local/new-mode-two.png'),
    },
    {
      key: 3,
      title: '统一平台-集中化管理',
      imgSrc: require('@/assets/images/sem-local/new-mode-three.png'),
    },
    {
      key: 4,
      title: '统一流程-全生命周期管理',
      imgSrc: require('@/assets/images/sem-local/new-mode-four.png'),
    },
    {
      key: 5,
      title: '统一审计-合规管控、风险预警',
      imgSrc: require('@/assets/images/sem-local/new-mode-five.png'),
    },
  ],
  // 实践成功案例
  successCasesData: [
    {
      key: 1,
      title: '国央企信创替代（中建八局）',
      imgSrc: require('@/assets/images/sem-local/success-cases-one.png'),
      show: true,
    },
    {
      key: 2,
      title: '快消零售（康师傅）',
      imgSrc: require('@/assets/images/sem-local/success-cases-two.png'),
      show: false,
    },
    {
      key: 3,
      title: '互联网+（网易）',
      imgSrc: require('@/assets/images/sem-local/success-cases-three.png'),
      show: false,
    },
    {
      key: 4,
      title: '金融行业（华夏银行）',
      imgSrc: require('@/assets/images/sem-local/success-cases-four.png'),
      show: false,
    },
    {
      key: 5,
      title: '人力资源服务（外企德科）',
      imgSrc: require('@/assets/images/sem-local/success-cases-five.png'),
      show: false,
    },
  ],
  // 实践成功按钮背景图
  successCaseBgList: [
    require('@/assets/images/sem-local/success-cases-one-bg.png'),
    require('@/assets/images/sem-local/success-cases-two-bg.png'),
    require('@/assets/images/sem-local/success-cases-three-bg.png'),
    require('@/assets/images/sem-local/success-cases-four-bg.png'),
    require('@/assets/images/sem-local/success-cases-five-bg.png'),
  ],
  // 关于e签宝
  eQianBao: [
    {
      key: 1,
      text:
        'e签宝面向企业组织、政务服务，提供全球领先的电子合同电子签章全生命周期服务。e签宝具备安全可信的电子签名与智能履约平台、物电一体化的印章管理平台、身份认证系统、区块链证据保全与管理平台、完善的司法服务体系等先进应用。',
    },
    {
      key: 2,
      text:
        'e签宝是业内唯一一家入选《2020胡润全球独角兽榜》的中国电子签名企业；于2021年9月完成中国电子签名行业首个E轮融资，金额达12亿元；同月宣布战略并购金格科技。',
    },
    {
      key: 3,
      text:
        '截至2021年8月底，e签宝已服务100+世界五百强客户，200+中国五百强客户，与各级政府联创1500多个政务服务应用场景，与3000+生态伙伴实现深度融合，是浙江省“最多跑一次”指定电子签供应商。',
    },
  ],
}